export const DISMISSED_AT_PREFIX = 'store-refresh-dismissed-at:';
export const SHOWING_STALE_MILLISECONDS = 30_000;
export const TAB_ID_SESSION_STORAGE_KEY = 'store-refresh-tab-id';
export const TAB_ID_CLAIM_SESSION_STORAGE_KEY = 'store-refresh-tab-id-claim';
